import {UMakeTypes} from "../../cars_data/cars_data";

type UMakeKey = keyof typeof UMakeTypes;

/** Normalize any make string to a URL path slug (`Alfa Romeo` → `alfaromeo`). */
export const toMakePathSlug = (make: string): string =>
    make
        .trim()
        .toLocaleLowerCase("pl")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "");

/**
 * Map URL/form make slug to the `type`/`make` value expected by WP get-cars APIs.
 * - Multi-word labels: `alfaromeo` → `Alfa Romeo`
 * - Slug-stored makes: `mercedesbenz` → `mercedesbenz` (not Mercedes-Benz)
 */
export const makeSlugToApiType = (slug?: string | null): string | undefined => {
    if (!slug) {
        return undefined;
    }
    const key = toMakePathSlug(slug) as UMakeKey;
    const label = UMakeTypes[key];
    if (!label) {
        return slug;
    }
    const labelAsSlug = toMakePathSlug(label);
    // Hyphenated display names that the API stores as compressed slugs (mercedesbenz)
    if (label.includes("-") && labelAsSlug === key) {
        return key;
    }
    return label;
};
